import React, { PureComponent } from 'react';
import Label from '../../../../components/svg/Label';
import { getHexColorString, getOpacityFromRgba, getRgba } from '../../../../helpers/helpers';
import FieldWrapper from './FieldWrapper';
import { getNextAutoNumber } from '../../../../helpers/AutoNumberUtility';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface AutoNumberFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor?: TypeMePlease;
  backgroundColor?: TypeMePlease;
  fontName?: string;
  fontSize?: number;
  padding?: number;
  editable?: boolean;
  value?: string | number;
}

export default class AutoNumberField extends PureComponent<AutoNumberFieldProps, TypeMePlease> {
  private placeHolderValue: string;

  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);

    this.placeHolderValue = '[##AUTO##]';
  }

  mouseDown() {
    if (!this.props.value || this.props.value.toString().indexOf(this.placeHolderValue) === 0) {
      getNextAutoNumber(this.props.fieldId).then((result) => {
        this.props.valueUpdated({ value: result.value });
      });
    }
  }

  render() {
    let text = this.props.value;
    let fontStyle = 'normal';
    let foregroundColor = this.props.foregroundColor;
    if (text && text.toString().indexOf(this.placeHolderValue) === 0) {
      text = 'Pending';
      fontStyle = 'italic';
      foregroundColor = getRgba('#777777');
    }

    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        <Label
          text={text}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(foregroundColor)}
          fontStyle={fontStyle}
        />
      </FieldWrapper>
    );
  }
}
